import { render, staticRenderFns } from "./addServantDia.vue?vue&type=template&id=351493c2&scoped=true"
import script from "./addServantDia.vue?vue&type=script&lang=js"
export * from "./addServantDia.vue?vue&type=script&lang=js"
import style0 from "./addServantDia.vue?vue&type=style&index=0&id=351493c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351493c2",
  null
  
)

export default component.exports